import { render, staticRenderFns } from "./CancelButton.vue?vue&type=template&id=1a16fa4a&scoped=true"
import script from "./CancelButton.vue?vue&type=script&lang=js"
export * from "./CancelButton.vue?vue&type=script&lang=js"
import style0 from "./CancelButton.vue?vue&type=style&index=0&id=1a16fa4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a16fa4a",
  null
  
)

export default component.exports